// Package Imports
import React, { FunctionComponent, ReactNode } from 'react';
import classNames from 'classnames';

// Style Imports
import styles from './heading.module.scss';

interface HeadingProps {
  children: ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
  fontFamily?: 'primary' | 'secondary' | 'accent';
  fontSize?: 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge';
  fontColor?:
  | 'mainPrimary'
  | 'mainSecondary'
  | 'mainDarkest'
  | 'mainLightest'
  | 'neutralLight'
  | 'neutralMedium'
  | 'neutralDark';
  bgColor?:
  | 'mainPrimary'
  | 'mainSecondary'
  | 'mainDarkest'
  | 'mainLightest'
  | 'neutralLight'
  | 'neutralMedium'
  | 'neutralDark';
}

const Heading: FunctionComponent<HeadingProps> = ({
  children,
  variant = 'h1',
  fontFamily = 'primary',
  fontSize = 'large',
  fontColor = 'mainPrimary',
  bgColor = 'mainLightest',
}) => {
  const classes = [styles.heading];
  classes.push(styles[`fontFamily_${fontFamily}`]);
  classes.push(styles[`fontSize_${fontSize}`]);
  classes.push(styles[`fontColor_${fontColor}`]);
  classes.push(styles[`bgColor_${bgColor}`]);

  const Tag: string = `${variant}`;
  const HeadingElement = Tag as
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'span';

  return (
    <HeadingElement className={classNames(classes)}>{children}</HeadingElement>
  );
};

export default Heading;
